<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-4">
    <h2>Projeto - Fonte Recurso</h2>
    <h3>Admin</h3>
  </div>
  <div class="col-lg-8 d-flex justify-content-end d-wrap">
    <div class="new-project">
      <a class="btn btn-primary" [routerLink]="novo()">Novo</a>
    </div>
  </div>
</div>

<div class="system-table p-h-lg">
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th>Nome</th>
          <th class="text-center width5">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of fonteRecursoslist">
          <td class="td-name"><span class="title-span">{{ item?.name }}</span></td>
          <td>
            <div class="btn-icon">
              <a class="icon-table" [routerLink]="editar(item?.id)">
                <img src="assets/images/svgs/editar1.svg" alt="Editar" tooltip="Editar" placement="bottom">
              </a>
            </div>
          </td>
        </tr>
        <tr *ngIf="!fonteRecursoslist?.length" class="border-b-radius">
          <td colspan="3" class="text-center">Nenhum Registro Cadastrado.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<app-loading [loader]="isLoading"></app-loading>